import { render, staticRenderFns } from "./video-red-packet-skeleton.vue?vue&type=template&id=54ed5fac&scoped=true&lang=pug&"
import script from "./video-red-packet-skeleton.vue?vue&type=script&lang=js&"
export * from "./video-red-packet-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./video-red-packet-skeleton.vue?vue&type=style&index=0&id=54ed5fac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed5fac",
  null
  
)

export default component.exports